module.exports = __webpack_public_path__ + "media/slow2.2acb9db0.mp4";